<script setup lang="ts">
const props = defineProps({
  rating: {
    type: Number,
    required: true,
  },
  modelRating: {
    type: String,
    default: '0',
  },
});

const colorClass = computed(() => {
  const rating = props.rating ? (props.rating / 20).toFixed(1) : 0;
  if (rating >= 4.4 && rating < 4.9) {
    return 'green-lite';
  } else if (rating >= 3.9 && rating < 4.4) {
    return 'yellow';
  } else if (rating >= 2.9 && rating < 3.9) {
    return 'orange';
  } else if (rating < 2.9) {
    return 'red';
  }
  return 'green';
});
</script>

<template>
  <div v-if="rating" :class="colorClass" class="color-rating body-m-semibold">
    {{ modelRating }}
  </div>
</template>

<style scoped lang="scss">
.color-rating {
  padding: 0 3px;
  border-radius: 2px;
  color: $white;
}

.green {
  background: #24c352;
}

.green-lite {
  background: #87c324;
}

.yellow {
  background: #c1c62e;
}

.orange {
  background: #f9b024;
}

.red {
  background: #ff8126;
}
</style>
